import type { FaireProductEntity } from "../../entity_types/product";

export const p_67vpjq5r: FaireProductEntity = {
  token: "p_67vpjq5r",
  type: "product",
  name: "Tiny Human Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6c849e411f7f191dfe651cfbbbd8b8ec8f9aaa599f3a156b4cd101a23d7284ea.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/ebaaca99fffb775217e104b0dd61d9a12b2bba54f55e2cdacdc3e2699f3bedd9/1528336812.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:19.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
